import { ehRotaDoPortalCliente } from './portalClienteRegras';

/**
 * Rotas que não recebem a maquinaria do ChatContar.
 *
 * Duas razões, e a segunda é a que dói: nelas o botão flutuante não faz sentido
 * (não há sessão nossa, ou a tela é quiosque), e o sinal de queda do chat
 * escreve no `document.title` — ver `chatAlertSignal` —, o que numa página à
 * vista de fora vira aviso interno exposto. Em 10/09/2026 a aba de
 * `/agenda-certificados`, que é o endereço divulgado para cliente, apareceu como
 * "⚠ ChatContar desconectado".
 *
 * A lista é fechada de propósito. Rota nova nasce COM chat, e só entra aqui
 * quando alguém decidir que ela é pública — o contrário deixaria uma tela
 * interna sem chat por esquecimento, o que ninguém percebe.
 *
 * A rota `*` (404) fica fora: ela é alcançável por link torto de quem já está
 * dentro do sistema, e não é endereço que se divulgue.
 */
export const ROTAS_SEM_CHAT: readonly string[] = [
  '/login',
  '/forgot-password',
  '/reset-password',
  '/ponto-tablet',
  '/rsvp',
  '/solicitacao',
  '/agendacertificado',
  '/agenda-certificados',
  '/tv',
  '/dashboard-tv',
  '/dashboard/tv',
  '/tv-dashboard',
];

const conjunto = new Set(ROTAS_SEM_CHAT);

/**
 * Diz se a rota deve ficar sem botão de chat e sem notificações.
 *
 * O Portal do Cliente fica fora por outro motivo: é a tela que o cliente vai
 * ver, e o chat é da equipe. Entra pelo prefixo, e não pela lista, porque são
 * várias subrotas — e no celular o botão flutuante cobria o menu inferior.
 */
export function rotaSemChat(pathname: string): boolean {
  return conjunto.has(pathname) || ehRotaDoPortalCliente(pathname);
}
